<mat-toolbar class="footer">
  <mat-toolbar-row class="footer-row">
  </mat-toolbar-row>
</mat-toolbar>
